const g = (e, r, a, o) => {
  const n = [a, {
    code: r,
    ...o || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(n, "warn", "react-i18next::", !0);
  s(n[0]) && (n[0] = `react-i18next:: ${n[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...n) : console?.warn && console.warn(...n);
}, t = {}, l = (e, r, a, o) => {
  s(a) && t[a] || (s(a) && (t[a] = /* @__PURE__ */ new Date()), g(e, r, a, o));
}, i = (e, r) => () => {
  if (e.isInitialized)
    r();
  else {
    const a = () => {
      setTimeout(() => {
        e.off("initialized", a);
      }, 0), r();
    };
    e.on("initialized", a);
  }
}, c = (e, r, a) => {
  e.loadNamespaces(r, i(e, a));
}, d = (e, r, a, o) => {
  if (s(a) && (a = [a]), e.options.preload && e.options.preload.indexOf(r) > -1) return c(e, a, o);
  a.forEach((n) => {
    e.options.ns.indexOf(n) < 0 && e.options.ns.push(n);
  }), e.loadLanguages(r, i(e, o));
}, f = (e, r, a = {}) => !r.languages || !r.languages.length ? (l(r, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: r.languages
}), !0) : r.hasLoadedNamespace(e, {
  lng: a.lng,
  precheck: (o, n) => {
    if (a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !n(o.isLanguageChangingTo, e)) return !1;
  }
}), s = (e) => typeof e == "string", u = (e) => typeof e == "object" && e !== null;
export {
  f as hasLoadedNamespace,
  u as isObject,
  s as isString,
  d as loadLanguages,
  c as loadNamespaces,
  g as warn,
  l as warnOnce
};
//# sourceMappingURL=help-center-knowledge-anatomies41.js.map
